(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3504],{

/***/ 51259:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blogSlug]",
      function () {
        return __webpack_require__(38410);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_Blog_BlogArticleDetail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58486);
/* harmony import */ var modules_Blog_blogApi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6153);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51776);
/* harmony import */ var modules_Meta_SocialMeta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88935);






const BlogDetail = ()=>{
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const slug = typeof router.query.blogSlug == "string" ? router.query.blogSlug : "";
    const blogArticleDetailApi = (0,modules_Blog_blogApi__WEBPACK_IMPORTED_MODULE_3__/* .useBlogArticleDetailApi */ .q)(slug);
    // const data = blogArticleDetailApi.data?.data;
    // const betaUrl = "https://beta-pwa.gokampus.com";
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        blogArticleDetailApi.initialFetch({
            slug
        }, {
            onSuccess (res) {
                setData(res?.data);
            }
        });
    }, [
        slug
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Meta_SocialMeta__WEBPACK_IMPORTED_MODULE_5__/* .SocialMeta */ .i, {
                title: data?.title + " | goKampus",
                image: data?.image_url,
                url: `https://www.gokampus.com/blog/${data?.slug}?hideHeader=false`,
                description: data?.content?.match(/<p>(.*)<\/p>/m) ? data?.content?.match(/<p>(.*)<\/p>/m)[0].replaceAll("<p>", "").replaceAll("</p>", "").replace(/<.*>/g, "") : null,
                type: "article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Blog_BlogArticleDetail__WEBPACK_IMPORTED_MODULE_2__/* .BlogArticleDetail */ .f, {
                    slug: slug,
                    data: data
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlogDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7870,7538,9155,5824,3426,7939,4631,7687,9504,8155,4299,3299,9774,2888,179], function() { return __webpack_exec__(51259); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);